import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
  addAccount,
  deleteAccount,
  getAccount,
  searchAccount,
  updateAccount,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function AccountMaster() {
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [ids, setIds] = useState(null);
  const [mainPage, setMainPage] = useState('1');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });

  const [initialValues, setInitialValues] = useState({
    name: '',
    partyName: '',
    city: '',
    area: '',
    mobileNumber: ''
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    partyName: Yup.string().required('Party Name is required'),
    city: Yup.string().required('City is required'),
    area: Yup.string().required('Area is required'),
    mobileNumber: Yup.string().required('Mobile Number is required'),
  });
  const toggle = () => {
    setShow(!show);
  };
  const updateToggle = () => {
    setUpdateModal(!updateModal);
  };
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const dispatch = useDispatch();
  const accountData = useSelector((state) => state.master);

  const [formData, setFormData] = useState({
    name: '',
    partyName: '',
    address: '',
    city: '',
    district: '',
    area: '',
    state: '',
    pincode: '',
    dlNo1: '',
    dlNo2: '',
    bankAccountNo: '',
    gstin: '',
    phoneNumber: '',
    mobileNumber: '',
    email: '',
  });

  const limits = {
    page: mainPage,
    limit: rowsPerPage,
  };

  const handleAddAccount = (values, { resetForm }) => {
    dispatch(addAccount(values, limits)).then(() => {
      toggle();
      resetForm();
    });
  };

  const handleUpadteAccount = (values) => {
    const payload = {
      name: values.name,
      partyName: values.partyName,
      address: values.address,
      city: values.city,
      district: values.district,
      area: values.area,
      state: values.state,
      pincode: values.pincode,
      dlNo1: values.dlNo1,
      dlNo2: values.dlNo2,
      bankAccountNo: values.bankAccountNo,
      gstin: values.gstin,
      phoneNumber: values.phoneNumber,
      mobileNumber: values.mobileNumber,
      email: values.email,
    };

    dispatch(updateAccount(payload, limits, ids)).then(() => {
      setUpdateModal(false);
    });
  };

  const handleDeleteAccount = () => {
    dispatch(deleteAccount(ids, limits)).then(() => {
      deleteToggle();
      setMainPage(1);
    });
  };

  const handleSearch = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
    };

    setSearchDefault(newSearchParams);
    const queryParams = new URLSearchParams(newSearchParams).toString();
    dispatch(searchAccount(queryParams, newSearchParams.page));
  };

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: parseInt(selected.selected) + 1,
    };
    setSearchDefault(updatedSearchParams);
    const queryParams = new URLSearchParams(updatedSearchParams).toString();
    dispatch(searchAccount(queryParams, updatedSearchParams.page));
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    accountData?.getAccount?.data?.totalCount / postPerPage,
  );

  useEffect(() => {
    if (searchQuery) {
      const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
      const queryParams = new URLSearchParams(updatedSearchParams).toString();
      dispatch(searchAccount(queryParams, updatedSearchParams.page));
    } else {
      dispatch(getAccount(limits));
    }
  }, [mainPage, rowsPerPage]);

  return (
    <>
      <div className="mt-[100px] d-flex justify-content-end">
        <div className="d-flex items-center gap-3">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={searchQuery}
              onChange={handleSearch}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <Button
            onClick={toggle}
            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Account
          </Button>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <div className='mb-3 flex items-center justify-between mt-5'>
          <h3 className="fw-bold">Account Master</h3>
          <div>
            Rows per page:
            <select
              value={rowsPerPage}
              onChange={handleRowsPerPageChange}
              className="ms-2 border rounded-md focus:outline-none"
            >
              <option value={10}>10</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={500}>500</option>
            </select>
          </div>
        </div>

        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Name</Th>
                <Th>Party Name</Th>
                <Th>Address</Th>
                <Th>City</Th>
                <Th>District</Th>
                <Th>Area</Th>
                <Th>State</Th>
                <Th>Pincode</Th>
                <Th>DL NO.1</Th>
                <Th>DL NO.2</Th>
                <Th>Bank Ac/No</Th>
                <Th>GSTN</Th>
                <Th>Phone Number</Th>
                <Th>Mobile Number</Th>
                <Th>Email Id</Th>
                <Th className="text-end">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {accountData?.getAccount?.data?.data?.length > 0 ? (
                accountData?.getAccount?.data?.data?.map((res) => {
                  return (
                    <Tr key={res._id}>
                      <Td>{res.name}</Td>
                      <Td>{res.partyName}</Td>
                      <Td>{res.address}</Td>
                      <Td>{res.city}</Td>
                      <Td>{res.district}</Td>
                      <Td>{res.area}</Td>
                      <Td>{res.state}</Td>
                      <Td>{res.pincode}</Td>
                      <Td>{res.dlNo1}</Td>
                      <Td>{res.dlNo2}</Td>
                      <Td>{res.bankAccountNo}</Td>
                      <Td>{res.gstin}</Td>
                      <Td>{res.phoneNumber}</Td>
                      <Td>{res.mobileNumber}</Td>
                      <Td>{res.email}</Td>
                      <Td style={{ minWidth: '200px' }}>
                        <div className="d-flex gap-3 justify-end">
                          <FaEdit
                            onClick={() => {
                              updateToggle();
                              setFormData(res);
                              setIds(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-success"
                            title="update"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteToggle();
                              setIds(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-danger"
                            title="delete"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <>
                  <Tr>
                    <Td colSpan={16} textAlign="center">
                      Account Not Found
                    </Td>
                  </Tr>
                </>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />

      {/* add problem */}

      <Modal show={show} onHide={toggle} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Add Account</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAddAccount}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('name', e.target.value)
                        }
                        value={values.name}
                        placeholder="Enter Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Party Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="partyName"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('partyName', e.target.value)
                        }
                        value={values.partyName}
                        placeholder="Enter Party Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="partyName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('address', e.target.value)
                        }
                        value={values.address}
                        placeholder="Enter Address"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('city', e.target.value)
                        }
                        value={values.city}
                        placeholder="Enter City"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>District</Form.Label>
                      <Form.Control
                        type="text"
                        name="district"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('district', e.target.value)
                        }
                        value={values.district}
                        placeholder="Enter District"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="district"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Area</Form.Label>
                      <Form.Control
                        type="text"
                        name="area"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('area', e.target.value)
                        }
                        value={values.area}
                        placeholder="Enter Area"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="area"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        type="text"
                        name="state"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('state', e.target.value)
                        }
                        value={values.state}
                        placeholder="Enter State"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Pincode</Form.Label>
                      <Form.Control
                        type="text"
                        name="pincode"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('pincode', e.target.value)
                        }
                        value={values.pincode}
                        placeholder="Enter Pincode"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="pincode"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>DL NO.1</Form.Label>
                      <Form.Control
                        type="text"
                        name="dlNo1"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('dlNo1', e.target.value)
                        }
                        value={values.dlNo1}
                        placeholder="Enter"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dlNo1"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>DL NO.2</Form.Label>
                      <Form.Control
                        type="text"
                        name="dlNo2"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('dlNo2', e.target.value)
                        }
                        value={values.dlNo2}
                        placeholder="Enter"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dlNo2"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Bank Ac/No</Form.Label>
                      <Form.Control
                        type="text"
                        name="bankAccountNo"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('bankAccountNo', e.target.value)
                        }
                        value={values.bankAccountNo}
                        placeholder="Enter Bank Ac/No"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="bankAccountNo"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>GSTN</Form.Label>
                      <Form.Control
                        type="text"
                        name="gstin"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('gstin', e.target.value)
                        }
                        value={values.gstin}
                        placeholder="Enter GSTN"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="gstin"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="phoneNumber"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('phoneNumber', e.target.value)
                        }
                        value={values.phoneNumber}
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="phoneNumber"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="mobileNumber"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('mobileNumber', e.target.value)
                        }
                        value={values.mobileNumber}
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="mobileNumber"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Email Id</Form.Label>
                      <Form.Control
                        type="text"
                        name="email"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('email', e.target.value)
                        }
                        value={values.email}
                        placeholder="Enter Email"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={toggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                >
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* update problem */}

      <Modal show={updateModal} onHide={updateToggle} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Update Consent</Modal.Title>
        </Modal.Header>

        <Formik
          enableReinitialize={true}
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpadteAccount}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('name', e.target.value)
                        }
                        value={values.name}
                        placeholder="Enter Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Party Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="partyName"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('partyName', e.target.value)
                        }
                        value={values.partyName}
                        placeholder="Enter Party Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="partyName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        type="text"
                        name="address"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('address', e.target.value)
                        }
                        value={values.address}
                        placeholder="Enter Address"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('city', e.target.value)
                        }
                        value={values.city}
                        placeholder="Enter City"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="city"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>District</Form.Label>
                      <Form.Control
                        type="text"
                        name="district"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('district', e.target.value)
                        }
                        value={values.district}
                        placeholder="Enter District"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="district"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Area</Form.Label>
                      <Form.Control
                        type="text"
                        name="area"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('area', e.target.value)
                        }
                        value={values.area}
                        placeholder="Enter Area"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="area"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>State</Form.Label>
                      <Form.Control
                        type="text"
                        name="state"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('state', e.target.value)
                        }
                        value={values.state}
                        placeholder="Enter State"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="state"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Pincode</Form.Label>
                      <Form.Control
                        type="text"
                        name="pincode"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('pincode', e.target.value)
                        }
                        value={values.pincode}
                        placeholder="Enter Pincode"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="pincode"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>DL NO.1</Form.Label>
                      <Form.Control
                        type="text"
                        name="dlNo1"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('dlNo1', e.target.value)
                        }
                        value={values.dlNo1}
                        placeholder="Enter"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dlNo1"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>DL NO.2</Form.Label>
                      <Form.Control
                        type="text"
                        name="dlNo2"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('dlNo2', e.target.value)
                        }
                        value={values.dlNo2}
                        placeholder="Enter"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="dlNo2"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Bank Ac/No</Form.Label>
                      <Form.Control
                        type="text"
                        name="bankAccountNo"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('bankAccountNo', e.target.value)
                        }
                        value={values.bankAccountNo}
                        placeholder="Enter Bank Ac/No"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="bankAccountNo"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>GSTN</Form.Label>
                      <Form.Control
                        type="text"
                        name="gstin"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('gstin', e.target.value)
                        }
                        value={values.gstin}
                        placeholder="Enter GSTN"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="gstin"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="phoneNumber"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('phoneNumber', e.target.value)
                        }
                        value={values.phoneNumber}
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="phoneNumber"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Mobile Number</Form.Label>
                      <Form.Control
                        type="text"
                        name="mobileNumber"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('mobileNumber', e.target.value)
                        }
                        value={values.mobileNumber}
                        placeholder="Enter Phone Number"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="mobileNumber"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-3">
                    <Form.Group className="mb-3">
                      <Form.Label>Email Id</Form.Label>
                      <Form.Control
                        type="text"
                        name="email"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('email', e.target.value)
                        }
                        value={values.email}
                        placeholder="Enter Email"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* delete problem */}

      <Modal show={deleteModal} onHide={deleteToggle}>
        {/* <Modal.Header closeButton>
                        <Modal.Title>Delete Problem</Modal.Title>
                    </Modal.Header> */}

        <Modal.Body className="p-5">
          <div>
            <PiWarningCircleBold className="text-7xl w-100 text-danger" />
          </div>
          <div className="text-center mt-4">
            <h3>Are You Sure ?</h3>
            <p className="text-md">
              Do you really want to delete these records?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeleteAccount}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
